
import React from 'react';
import Layout from '../../components/Layout';
import SubNavBar from "../../components/SubNavBar/SubNavBar"
import Settings from './Settings';


function action({ store, params, query }) {
  const title = store.getState().siteSettings?.data?.siteTitle
  const description = store.getState().siteSettings?.data?.metaDescription;
  let isAuthenticated = store.getState().runtime.isAuthenticated;

  if (!isAuthenticated) {
    return { redirect: '/' }
  }
  return {
    title,
    description,
    component: (
      <Layout>
        <div className={isAuthenticated ? "subPageMainContainer" : "withoutPageMainContainer"}>
          {isAuthenticated && <SubNavBar />}
          <Settings />
        </div>
      </Layout>
    ),
  };
}

export default action;
